import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPauseSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.66671 6.5H10.8334C11.4317 6.5 11.9167 6.98502 11.9167 7.58333V18.4167C11.9167 19.015 11.4317 19.5 10.8334 19.5H8.66671C8.0684 19.5 7.58337 19.015 7.58337 18.4167V7.58333C7.58337 6.98502 8.0684 6.5 8.66671 6.5ZM15.1667 6.5H17.3334C17.9317 6.5 18.4167 6.98502 18.4167 7.58333V18.4167C18.4167 19.015 17.9317 19.5 17.3334 19.5H15.1667C14.5684 19.5 14.0834 19.015 14.0834 18.4167V7.58333C14.0834 6.98502 14.5684 6.5 15.1667 6.5Z",
		fill: "#4D4D54"
	})
});
export default SvgPauseSmall;
